module.exports = __webpack_public_path__ + "img/step1.d47357b7.png";